import React from 'react';
import styled from 'styled-components';
import { FaRegCircle } from 'react-icons/fa';
import Layout from '@components/layout';
import SEO from '@components/seo';
import { PageHeader, Feed } from '@components';

const Container = styled.div`
  position: relative;
  height: 100vh;
  padding: 24px;
  height: calc(100% - 48px);
  overflow: auto;
`;

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Projects" />
      <Container>
        <PageHeader title="Projects">
          <FaRegCircle style={{ fontSize: '20px' }} />
        </PageHeader>
        <Feed />
      </Container>
    </Layout>
  );
};

export default IndexPage;
